// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"586d319a","911":"fe7c0285"}[chunkId] + ".chunk.js";
};